export enum ResumeVisibility {
  Private = "private",
  Public = "public",
}

